import { render, staticRenderFns } from "./EventDetailsCard.vue?vue&type=template&id=a36fdef8"
import script from "./EventDetailsCard.vue?vue&type=script&lang=js"
export * from "./EventDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports